// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as privateIndexRouteImport } from './routes/(private)/index'
import { Route as privateOrganizationsRouteRouteImport } from './routes/(private)/organizations/route'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as privateAuditIndexRouteImport } from './routes/(private)/audit/index'
import { Route as privateOperatorsIndexRouteImport } from './routes/(private)/operators/index'
import { Route as privateOrganizationsIndexRouteImport } from './routes/(private)/organizations/index'
import { Route as privateOrganizationsOrganizationIdRouteRouteImport } from './routes/(private)/organizations/$organizationId/route'
import { Route as AcceptInviteCodeIndexRouteImport } from './routes/accept-invite/$code/index'
import { Route as privateOrganizationsOrganizationIdIndexRouteImport } from './routes/(private)/organizations/$organizationId/index'
import { Route as privateOrganizationsOrganizationIdPeopleRouteImport } from './routes/(private)/organizations/$organizationId/people'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const privateIndexRoute = privateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateRouteRoute
          })
const privateOrganizationsRouteRoute = privateOrganizationsRouteRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => privateRouteRoute
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const privateAuditIndexRoute = privateAuditIndexRouteImport.update({
            id: '/audit/',path: '/audit/',getParentRoute: () => privateRouteRoute
          })
const privateOperatorsIndexRoute = privateOperatorsIndexRouteImport.update({
            id: '/operators/',path: '/operators/',getParentRoute: () => privateRouteRoute
          })
const privateOrganizationsIndexRoute = privateOrganizationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateOrganizationsRouteRoute
          })
const privateOrganizationsOrganizationIdRouteRoute = privateOrganizationsOrganizationIdRouteRouteImport.update({
            id: '/$organizationId',path: '/$organizationId',getParentRoute: () => privateOrganizationsRouteRoute
          })
const AcceptInviteCodeIndexRoute = AcceptInviteCodeIndexRouteImport.update({
            id: '/accept-invite/$code/',path: '/accept-invite/$code/',getParentRoute: () => rootRouteImport
          })
const privateOrganizationsOrganizationIdIndexRoute = privateOrganizationsOrganizationIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateOrganizationsOrganizationIdRouteRoute
          })
const privateOrganizationsOrganizationIdPeopleRoute = privateOrganizationsOrganizationIdPeopleRouteImport.update({
            id: '/people',path: '/people',getParentRoute: () => privateOrganizationsOrganizationIdRouteRoute
          })





const privateOrganizationsOrganizationIdRouteRouteChildren = {
  privateOrganizationsOrganizationIdPeopleRoute: privateOrganizationsOrganizationIdPeopleRoute,privateOrganizationsOrganizationIdIndexRoute: privateOrganizationsOrganizationIdIndexRoute
}

const privateOrganizationsOrganizationIdRouteRouteWithChildren = privateOrganizationsOrganizationIdRouteRoute._addFileChildren(privateOrganizationsOrganizationIdRouteRouteChildren)



const privateOrganizationsRouteRouteChildren = {
  privateOrganizationsOrganizationIdRouteRoute: privateOrganizationsOrganizationIdRouteRouteWithChildren,privateOrganizationsIndexRoute: privateOrganizationsIndexRoute
}

const privateOrganizationsRouteRouteWithChildren = privateOrganizationsRouteRoute._addFileChildren(privateOrganizationsRouteRouteChildren)



const privateRouteRouteChildren = {
  privateOrganizationsRouteRoute: privateOrganizationsRouteRouteWithChildren,privateIndexRoute: privateIndexRoute,privateAuditIndexRoute: privateAuditIndexRoute,privateOperatorsIndexRoute: privateOperatorsIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)

const rootRouteChildren = {
  privateRouteRoute: privateRouteRouteWithChildren,LoginIndexRoute: LoginIndexRoute,AcceptInviteCodeIndexRoute: AcceptInviteCodeIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)